import { useContext } from 'react';
import { HostWalletContext } from '../contexts/HostWalletContext';

const useHostWallet = () => useContext(HostWalletContext);

export default useHostWallet;
